var _path, _line, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 318,
    height: 88,
    viewBox: "0 0 318 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M119.533 39L120.484 36.3224H124.306L125.257 39H126.457L122.986 29.5455H121.804L118.332 39H119.533ZM120.844 35.3068L122.358 31.0412H122.432L123.946 35.3068H120.844ZM128.872 29.5455H127.782V39H128.872V29.5455ZM133.84 39.1477C135.281 39.1477 136.333 38.4276 136.666 37.3565L135.613 37.0611C135.336 37.7997 134.694 38.169 133.84 38.169C132.562 38.169 131.68 37.3427 131.629 35.8239H136.776V35.3622C136.776 32.7216 135.207 31.8168 133.729 31.8168C131.809 31.8168 130.535 33.331 130.535 35.5099C130.535 37.6889 131.791 39.1477 133.84 39.1477ZM131.629 34.8821C131.703 33.7788 132.483 32.7955 133.729 32.7955C134.911 32.7955 135.668 33.6818 135.668 34.8821H131.629ZM138.434 39H139.523V34.5128C139.523 33.5526 140.28 32.8509 141.314 32.8509C141.605 32.8509 141.905 32.9062 141.979 32.9247V31.8168C141.854 31.8075 141.568 31.7983 141.407 31.7983C140.557 31.7983 139.819 32.2784 139.56 32.9801H139.486V31.9091H138.434V39ZM146.799 31.9091H145.285V30.2102H144.195V31.9091H143.124V32.8324H144.195V37.2642C144.195 38.5014 145.192 39.0923 146.116 39.0923C146.522 39.0923 146.78 39.0185 146.928 38.9631L146.706 37.9844C146.614 38.0028 146.466 38.0398 146.226 38.0398C145.746 38.0398 145.285 37.892 145.285 36.9688V32.8324H146.799V31.9091ZM154.975 39.1477C156.544 39.1477 157.578 38.1875 157.763 36.9318H156.673C156.47 37.7074 155.824 38.169 154.975 38.169C153.682 38.169 152.851 37.098 152.851 35.4545C152.851 33.848 153.7 32.7955 154.975 32.7955C155.935 32.7955 156.507 33.3864 156.673 34.0327H157.763C157.578 32.7031 156.452 31.8168 154.956 31.8168C153.036 31.8168 151.761 33.331 151.761 35.4915C151.761 37.6151 152.98 39.1477 154.975 39.1477ZM162.236 39.1477C164.157 39.1477 165.449 37.6889 165.449 35.4915C165.449 33.2756 164.157 31.8168 162.236 31.8168C160.316 31.8168 159.023 33.2756 159.023 35.4915C159.023 37.6889 160.316 39.1477 162.236 39.1477ZM162.236 38.169C160.777 38.169 160.113 36.9134 160.113 35.4915C160.113 34.0696 160.777 32.7955 162.236 32.7955C163.695 32.7955 164.36 34.0696 164.36 35.4915C164.36 36.9134 163.695 38.169 162.236 38.169ZM168.202 29.5455H167.112V39H168.202V29.5455ZM173.078 39.1477C174.998 39.1477 176.291 37.6889 176.291 35.4915C176.291 33.2756 174.998 31.8168 173.078 31.8168C171.158 31.8168 169.865 33.2756 169.865 35.4915C169.865 37.6889 171.158 39.1477 173.078 39.1477ZM173.078 38.169C171.619 38.169 170.954 36.9134 170.954 35.4915C170.954 34.0696 171.619 32.7955 173.078 32.7955C174.537 32.7955 175.202 34.0696 175.202 35.4915C175.202 36.9134 174.537 38.169 173.078 38.169ZM177.954 39H179.044V34.5128C179.044 33.5526 179.801 32.8509 180.835 32.8509C181.126 32.8509 181.426 32.9062 181.5 32.9247V31.8168C181.375 31.8075 181.089 31.7983 180.927 31.7983C180.078 31.7983 179.339 32.2784 179.081 32.9801H179.007V31.9091H177.954V39Z",
    fill: "black"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 59,
    y1: 34.5,
    x2: 109,
    y2: 34.5,
    stroke: "#919191"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44 68C57.2548 68 68 57.2548 68 44C68 30.7452 57.2548 20 44 20C30.7452 20 20 30.7452 20 44C20 57.2548 30.7452 68 44 68Z",
    fill: "#009B00"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33 36C33 34.8954 33.8954 34 35 34H54C55.1046 34 56 34.8954 56 36V51C56 52.1046 55.1046 53 54 53H35C33.8954 53 33 52.1046 33 51V36Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46 51.8994L38 58L38.0268 48L46 51.8994Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3929 39H49.6071",
    stroke: "#009B00",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3929 43H49.6071",
    stroke: "#009B00",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.375 47H44.625",
    stroke: "#009B00",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5 38.5C58.2614 38.5 60.5 36.2614 60.5 33.5C60.5 30.7386 58.2614 28.5 55.5 28.5C52.7386 28.5 50.5 30.7386 50.5 33.5C50.5 36.2614 52.7386 38.5 55.5 38.5Z",
    fill: "#D4240D",
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 88,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/Alert.34a6b1f3254c386df72f36bcf278744a.svg";
export { ForwardRef as ReactComponent };